export default __webpack_public_path__ + "static/media/logo-sm-admin.29415837.png";